export default __webpack_public_path__ + "static/media/plate.b885757a.png";